import React from "react"
import { PanelBarGLPure, GridSelectionHLPure } from "../../pures";
import { Grid } from '@material-ui/core'
import "./consult-negotiation-negotiators.css";

const ConsultNegotationNegotiators = (props) => {

    let {
        t,  
        negotiators
    } = props

    let heightGrid = '320px'

    if(negotiators.length === 1 || negotiators.length === 0){
        heightGrid = '110px'
    }else if(negotiators.length === 2){
        heightGrid = '180px'
    }else if(negotiators.length === 3){
        heightGrid = '280px'
    }else{
        heightGrid = '320px'
    }

    const headerColumnOne = (props) => {
        return <span className="consultNegotationNegotiators-header-cell-one">{props.title}</span>;
    };

    const headerColumnTwo = (props) => {
        return <span className="consultNegotationNegotiators-header-cell-two">{props.title}</span>;
    };

    const cellColumnOne = (props) => {
        return (
            <td className='consultNegotationNegotiators-cell-one'>
                <span className="gridHLPure-userName">
                    {props.dataItem.fullName}
                </span>
            </td>
        );
    };

    const cellColumnTwo = (props) => {
        return (
            <td className='consultNegotationNegotiators-cell-two'>
                <span className="gridHLPure-fieldSubtitle">
                    {props.dataItem.email}
                </span>
            </td>
        );
    };

    
    return(
        <div className="consultNegotationNegotiators-negotiators">
            <PanelBarGLPure
                expandedPanel={true}
                titlePanel={t("consultNegotiation.panels.bar.title.negotiators")}
                className='consultNegotationNegotiators'
            >
                <Grid item className="consultNegotationNegotiators-grid-documents">
                    <GridSelectionHLPure
                        styleGeneral={true}
                        styleGeneralClass={"consultNegotationNegotiators-general-grid"}
                        pageable={false}
                        skip={0}
                        take={negotiators.length}
                        dataGrid={negotiators}
                        filter={false}
                        columnTwo={true}
                        titleRow1={t("consultNegotiation.negotiators.grid.title.1")}
                        titleRow2={t("consultNegotiation.negotiators.grid.title.2")}
                        headerColumnOne={headerColumnOne}
                        headerColumnTwo={headerColumnTwo}
                        cellColumnOne={cellColumnOne}
                        cellColumnTwo={ cellColumnTwo }
                        styleGrid={{ height: heightGrid }}
                    />
                </Grid>            
            </PanelBarGLPure>
        </div>
    )
}

export { ConsultNegotationNegotiators as default }